import React, {Component} from 'react';
import {render} from 'react-dom';

export default class Header extends Component {
    render() {
        return (
            <header id="masthead">
                <div className="padding-t40"></div>
            </header>
        )
    }
}